import Api from './api.js'
import response from '../../../utils/response.js'
import cachedRequest from '../../../../../../utils/cached-request'
import {HEADER_PARAMS_KEYS} from 'fe-coms-share/paas/constants'
import { requestLookUpRelationLayout } from '../../../utils/share'
// 值对象-对象的主属性列表
export async function requestValueObject (
  {
    type,
    url,
    params
  },
  headerParams
) {
  const {content, isOk} = await cachedRequest(
    {type, url},
    params,
    false,
    {
      authError: false
    },
    headerParams
  )

  if (isOk) {
    return content
  }
}

// 值对象-主从关联对象的主属性列表
export async function requestMasterRelationValueObject (
  {
    tenantType,
    relateObjectApiName
  },
  headerParams
) {
  const {type, url} = Api.getRelationMainFieldList
  const uri = `${url}/${relateObjectApiName}`
  const {content, isOk} = await cachedRequest(
    {type, url: uri},
    {},
    false,
    {
      authError: false
    },
    headerParams
  )

  if (isOk) {
    return content
  }
}


// 值对象-查找关联列表
export async function requestFetchData (params, headerParams) {
  const { tenantType, relateObjectApiName, objectApiName, apiName, tabApiName } = params
  const {type, url} = Api.mainFieldAllTabList
  const uri = `${url}/${tenantType}/${relateObjectApiName}/${objectApiName}/${apiName}`
  const data = await response(
    {
      method: type,
      url: uri,
      params: params,
      headerParams: {
        ...headerParams,
        [HEADER_PARAMS_KEYS.tabApiName]: tabApiName
      },
      option: {
        authError: false,
        showError: false
      }
    }
  )

  if (data.isOk) {
    return data
  }
}

export {
  requestLookUpRelationLayout
}